/**
 * 相册服务 - 提供时光相册功能的API接口
 */
import apiClient from './apiClient';

/**
 * 获取学生相册照片数据
 * 将考勤记录中的照片转换为相册格式
 * 
 * @param {number} studentId - 学生ID
 * @param {Object} options - 查询选项
 * @param {string} [options.startDate] - 开始日期 YYYY-MM-DD
 * @param {string} [options.endDate] - 结束日期 YYYY-MM-DD
 * @param {string} [options.courseName] - 课程名称筛选
 * @returns {Promise<{photos: Array, total: number, availableTags: Array}>}
 */
export const getStudentAlbumPhotos = async (studentId, options = {}) => {
  const params = {
    student_id: studentId,
    ...options
  };
  
  try {
    const response = await apiClient.get('/api/album/photos', params);
    return response;
  } catch (error) {
    console.error('获取相册照片失败:', error);
    throw error;
  }
};

/**
 * 获取学生可用的课程标签
 * 
 * @param {number} studentId - 学生ID
 * @returns {Promise<{tags: Array<string>, total: number}>}
 */
export const getAvailableCourseTags = async (studentId) => {
  try {
    const response = await apiClient.get('/api/album/tags', { student_id: studentId });
    return response;
  } catch (error) {
    console.error('获取课程标签失败:', error);
    throw error;
  }
};

import { convertToProxyUrl } from '../utils/imageUrl';

/**
 * 从考勤记录列表提取照片数据（本地转换）
 * 当后端API未就绪时，可以在前端直接从考勤记录提取照片
 * 
 * @param {Array} attendanceRecords - 考勤记录列表
 * @returns {Array} 照片数组，格式适配PhotoAlbumPlayer组件
 */
export const extractPhotosFromRecords = (attendanceRecords) => {
  const photos = [];
  
  (attendanceRecords || []).filter(record => record.status !== 'VOIDED').forEach(record => {
    // 提取作品照片
    if (record.session_artwork_photos_urls && Array.isArray(record.session_artwork_photos_urls)) {
      record.session_artwork_photos_urls.forEach((url, index) => {
        photos.push({
          id: `artwork-${record.id}-${index}`,
          url: convertToProxyUrl(url),
          date: record.date || record.attendance_date,
          course_name: record.course_name || '未分类',
          description: record.student_creative_idea || record.remarks || '',
          type: 'artwork'
        });
      });
    }
    
    // 提取课堂照片
    if (record.classroom_photos_urls && Array.isArray(record.classroom_photos_urls)) {
      record.classroom_photos_urls.forEach((url, index) => {
        photos.push({
          id: `classroom-${record.id}-${index}`,
          url: convertToProxyUrl(url),
          date: record.date || record.attendance_date,
          course_name: record.course_name || '未分类',
          description: record.remarks || '',
          type: 'classroom'
        });
      });
    }
  });
  
  return photos;
};

export default {
  getStudentAlbumPhotos,
  getAvailableCourseTags,
  extractPhotosFromRecords
};
